module.exports = __webpack_public_path__ + "img/Steor-Icon-06.7e765950.svg";